module.exports = __webpack_public_path__ + "static/media/logo.ca59a0c3.pdn";